const STORAGE_KEY = "abcAppSession";
const FIREBASE_LOGIN_AT_KEY = "abcFirebaseLoginAt";

const MINUTE_MS = 60 * 1000;
const HOUR_MS = 60 * MINUTE_MS;

/** Agent/broker: 30 minutes. Admin/superuser (and other office roles): 3 hours. */
export function getSessionTimeoutMs(role) {
  const r = String(role || "").toLowerCase();
  if (r === "agent" || r === "broker") return 30 * MINUTE_MS;
  return 3 * HOUR_MS;
}

export function getFirebaseLoginAt() {
  const raw = localStorage.getItem(FIREBASE_LOGIN_AT_KEY);
  const n = Number(raw);
  return Number.isFinite(n) && n > 0 ? n : null;
}

export function setFirebaseLoginAt(ts = Date.now()) {
  localStorage.setItem(FIREBASE_LOGIN_AT_KEY, String(ts));
}

export function clearFirebaseLoginAt() {
  localStorage.removeItem(FIREBASE_LOGIN_AT_KEY);
}

export function getLoginAt(firebaseUser, session) {
  if (session?.loginAt) {
    const n = Number(session.loginAt);
    if (Number.isFinite(n) && n > 0) return n;
  }
  if (firebaseUser) return getFirebaseLoginAt();
  return null;
}

export function getAppSession() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function setAppSession(session) {
  if (!session) {
    localStorage.removeItem(STORAGE_KEY);
    return;
  }
  localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
}

export function clearAppSession() {
  localStorage.removeItem(STORAGE_KEY);
}

/** Full logout — clears JWT session and Firebase login timestamp. */
export function clearAllAuthSession() {
  clearAppSession();
  clearFirebaseLoginAt();
}

export function getAppRole(firebaseUser, session) {
  if (session?.user?.role) return session.user.role;
  if (firebaseUser) return "admin";
  return null;
}

export function isAgentRecordLocked(record, role) {
  if (role !== "agent" || !record) return false;
  if (isTradeFinalized(record)) return true;
  if (record.lockedBySuperUser) return true;
  if (record.workflowStatus === "approved") return true;
  if (record.createdByRole && record.createdByRole !== "agent") return true;
  if (!record.createdByRole && !record.createdByEmail) return true;
  return false;
}

export function isTradeFinalized(record) {
  if (!record) return false;
  if (record.isFinalized) return true;
  return Boolean(record.keyInfo?.finalizedDate);
}

export function workflowLabel(record) {
  if (!record) return "";
  if (isTradeFinalized(record)) {
    return "Finalized";
  }
  if (record.lockedBySuperUser || record.workflowStatus === "approved") {
    return "Reviewed";
  }
  if (record.workflowStatus === "draft") {
    return "Draft";
  }
  if (record.createdByRole === "agent") {
    return "Draft";
  }
  return "";
}
